import { ColumnDef } from "@tanstack/react-table";
import { ConflictIcon, MatchIcon } from "assets";
import { DataTable } from "components/data-table";

export interface BasicExpectationsTableItem {
  label: string;
  expectation: string;
  response: string;
  result: string;
}

interface BasicExpectationsTableProps {
  tableBodyItems: BasicExpectationsTableItem[];
  /** @deprecated No longer used — kept for backward compatibility */
  tableBodyItemClassName?: string;
  /** @deprecated No longer used — kept for backward compatibility */
  tableBodyRowClassName?: string;
}

const columns: ColumnDef<BasicExpectationsTableItem, unknown>[] = [
  {
    id: "label",
    header: "",
    meta: { className: "w-[26%] align-top break-words" },
    cell: ({ row }) => (
      <span className="text-[#1D2939] font-medium">{row.original.label}</span>
    ),
  },
  {
    id: "expectation",
    header: "Expectation Metric",
    meta: { className: "w-[30%] align-top break-words" },
    cell: ({ row }) => (
      <span className="text-[#667085]">{row.original.expectation}</span>
    ),
  },
  {
    id: "response",
    header: "Candidate's Response",
    meta: { className: "w-[30%] align-top break-words" },
    cell: ({ row }) => (
      <span className="text-[#667085]">{row.original.response}</span>
    ),
  },
  {
    id: "result",
    header: "Result",
    meta: { className: "w-[14%] min-w-[60px] align-top" },
    cell: ({ row }) => {
      const isMatch = row.original.result === "match";
      return (
        <span
          className={`capitalize flex items-center gap-2 font-medium ${
            isMatch ? "text-[#149B32]" : "text-[#E74444]"
          }`}
        >
          <span className="sm:inline-block hidden">{row.original.result}</span>
          {isMatch ? (
            <MatchIcon className="sm:w-[13px] sm:h-[13px] w-[12px] h-[12px] mt-1 flex-shrink-0" />
          ) : (
            <ConflictIcon className="sm:w-[15px] sm:h-[15px] w-[12px] h-[12px] flex-shrink-0" />
          )}
        </span>
      );
    },
  },
];

const BasicExpectationsTable: React.FC<BasicExpectationsTableProps> = ({
  tableBodyItems,
}) => {
  return (
    <div className="w-full overflow-x-auto">
      <div className="min-w-[560px]">
        <DataTable
          columns={columns}
          data={tableBodyItems}
          rowBaseClassName="text-[11px] sm:text-[13px] md:text-[15px]"
          cellBaseClassName="px-3 sm:px-4 py-3 align-top"
          headerCellClassName="px-3 sm:px-4 py-3 text-left text-base font-medium text-[#101323]"
          headerClassName="bg-white font-medium sm:text-sm text-[12px] text-[#101323]"
        />
      </div>
    </div>
  );
};

export { BasicExpectationsTable };
